import { APIUrls } from "../../Constants/ApiUrls";
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const NotificationController = {
  // stato della posta del cliente e ultimi invii (solo admin e installatore)
  GetNotifications: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.NOTIFICATIONS.NOTIFICATIONS_URL;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  Retry: async (id: number, callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.NOTIFICATIONS.NOTIFICATIONS_RETRY.replace(":id", String(id));
    request.method = "POST";
    request.payload = {};
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default NotificationController;
